// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ugwIZV0wB3c6W4 {
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: var(--ds-space-100, 8px) var(--ds-space-300, 24px);
  color: var(--ds-text, #172b4d);
  font-size: 20px;
  text-decoration: none;
}
.ugwIZV0wB3c6W4:hover {
  color: var(--ds-text, #172b4d);
}
.WuZuYT3VOT1orG {
  background-color: var(--ds-link, #0c66e4);
  color: var(--ds-text-inverse, #ffffff);
}
.WuZuYT3VOT1orG:hover {
  background-color: var(--ds-background-brand-bold-hovered, #0055cc);
  color: var(--ds-text-inverse, #ffffff);
}
.WizniJkRlb1ciP {
  display: flex;
  align-items: stretch;
  margin-left: auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonLink": `ugwIZV0wB3c6W4`,
	"primaryButtonLink": `WuZuYT3VOT1orG`,
	"buttonGroup": `WizniJkRlb1ciP`
};
export default ___CSS_LOADER_EXPORT___;
